import cx from 'classnames';

import Text from 'lib/common/components/Text';

import styles from './iq-result-body.module.scss';

interface IQResultBodyProps {
  title: string;
  description: string | React.ReactNode;
  isThinking?: boolean;
}

export default function IQResultBody({ title, description, isThinking }: IQResultBodyProps) {
  return (
    <div className={styles['iq-result-body']}>
      <Text type="heading3" className={styles['iq-result-body__title']}>
        {title}
      </Text>
      <div className={styles['iq-result-body__description-container']}>
        <Text
          preLine
          type="body"
          className={cx(styles['iq-result-body__description'], {
            [styles['iq-result-body__description--thinking']]: isThinking,
          })}
        >
          {description}
        </Text>
      </div>
    </div>
  );
}
